import React, { useEffect, useState } from "react";
import api from "../../utils/apiAuth";
import Select from "react-select"; // react-select kütüphanesini import ediyoruz

const Positions = ({ positions, setPositions }) => {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null); // Seçilen değeri obje olarak tutacağız

  // API'den yetkinlikleri çekme
  useEffect(() => {
    const fetchPositions = async () => {
      try {
        const response = await api.get("/positions/positionNames");
        console.log("Pozisyonlar:", response.data.data);
        setOptions(response.data.data || []); // API'den gelen yetkinlikleri state'e ekle
      } catch (error) {
        console.error("pozisyonlar alınırken hata oluştu:", error);
        setOptions([]); // Hata durumunda boş dizi
      }
    };
    fetchPositions();
  }, []);

  // react-select için özel stil tanımları (InputYeni'den alınmış)
  const customStyles = {
    control: (provided) => ({
      ...provided,
      maxWidth: "424px",
      height: "48px",
      borderRadius: "8px",
      borderWidth: "1px",
      borderColor: "rgba(203, 212, 225, 1)",
      boxShadow: "none",
      padding: "0 12px",
      display: "flex",
      justifyContent: "space-between",
      "&:hover": {
        borderColor: "rgba(203, 212, 225, 1)",
      },
      "&:focus": {
        borderColor: "rgba(203, 212, 225, 1)",
        outline: "none",
      },
    }),
    option: (provided) => ({
      ...provided,
      backgroundColor: "white",
      color: "rgba(100, 116, 139, 1)",
      "&:hover": {
        backgroundColor: "rgba(244, 255, 220, 1)",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgba(100, 116, 139, 1)",
    }),
    menu: (provided) => ({
      ...provided,
      maxWidth: "424px",
      borderRadius: "8px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "rgba(100, 116, 139, 1)",
    }),
  };

  const customComponents = {
    IndicatorSeparator: () => null, // Ayırıcı çizgiyi kaldırır
  };

  // API'den gelen options'ı react-select formatına dönüştürme
  const selectOptions = options.map((option) => ({
    label: option.name,
    value: option.name,
  }));

  const handleChange = (selectedOption) => {
    setSelectedValue(selectedOption); // Seçilen obje
    setPositions([selectedOption.value]); // Üst bileşene seçilen değeri aktar
  };
  return (
    <div className="w-full">
      <div className="flex flex-col gap-2">
        <label className="labelEdit">
          Projelerde Hangi Rolü Üstlenmek İstiyorsun?{" "}
        </label>
        <div>
          <Select
            options={selectOptions} // API'den gelen options
            value={selectedValue} // Seçilen değer
            onChange={handleChange}
            placeholder="Bir pozisyon seçiniz"
            styles={customStyles} // Özel stilleri uyguluyoruz
            components={customComponents} // Özel component'leri uyguluyoruz
            isSearchable={true} // Harfe göre filtreleme aktif
            classNamePrefix="react-select"
            required={positions.length === 0}
          />
        </div>
      </div>
    </div>
  );
};

export default Positions;
